import script from "./SnippetItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SnippetItem.vue?vue&type=script&setup=true&lang=js"

import "./SnippetItem.vue?vue&type=style&index=0&id=3a22558a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a22558a"]])

export default __exports__